import { FolderPlus, Plus } from 'lucide-react';
import { Button, PageHeader } from '@/shared/components';
import { AkteAutoFilingBanner } from './AkteAutoFilingBanner';
import { formatBytes } from '@/shared/lib/format';
import type { AkteSummary } from './akteSummary';

interface Props {
  summary: AkteSummary;
  onNewFolder: () => void;
  onUpload: () => void;
}

/** Page-Header der Akte: Titel + Kennzahlen + Aktionen + Auto-Filing-Banner. */
export function AkteHeader({ summary, onNewFolder, onUpload }: Props) {
  const description = `${summary.totalFiles} Dokumente · ${formatBytes(summary.totalSize)} · ${summary.occupied}/10 Kategorien belegt`;
  return (
    <>
      <PageHeader
        eyebrow="Apartment"
        title="Ihre digitale"
        titleAccent="Akte"
        description={description}
        actions={
          <>
            <Button variant="ghost" leftIcon={<FolderPlus size={14} />} onClick={onNewFolder}>
              Neuer Ordner
            </Button>
            <Button variant="brand" leftIcon={<Plus size={14} />} onClick={onUpload}>
              Datei hochladen
            </Button>
          </>
        }
      />
      <AkteAutoFilingBanner
        totalFiles={summary.totalFiles}
        totalSizeBytes={summary.totalSize}
        occupiedCategories={summary.occupied}
        lastAutoFiled={summary.lastAutoFiled}
      />
    </>
  );
}
